import type { Vehicle } from '../../Entities/Vehicle/Vehicle.entity';
import type { PromotionMetadata } from '../../Entities/Vehicle/VehiclePromotionMetadata.entity';

export const getPromotions = (vehicle: Vehicle | null) => {
  if (!vehicle || !vehicle?.promotionMetadata)
    return {
      count: 0,
      hasPromotions: false,
      promotions: [],
    };

  // COMMERCIAL_RECOMMENDATIONS are not a type of promotion that we add UI elements to the PLP or PDP so filter out
  const promotions = vehicle.promotionMetadata.filter(
    promotion => !promotion.promotionCode.includes('COMMERCIAL_RECOMMENDATION'),
  );
  const count = promotions.length;
  const hasPromotions = count > 0;
  const isFreeDelivery = promotions.some(promotion => promotion.type === 'Delivery');
  const isHeycarDaysCampaign = !!promotions.find(promotion =>
    promotion.promotionCode.includes('HEYCAR_DAYS_DISCOUNT'),
  );

  return {
    count,
    hasPromotions,
    promotions,
    isFreeDelivery,
    isHeycarDaysCampaign,
  };
};

export const showBadge = (promotion: PromotionMetadata, page: string) => {
  const isPlp = promotion.settings.plpBadgeActive;
  const isPdp = promotion.settings.pdpBadgeActive;

  if ((page === 'plp' && isPlp) || (page === 'pdp' && isPdp)) return promotion;
  return;
};
